import { makeStateKey } from '@angular/core';
import { PageFullUrls } from 'ctt-babylon';

export const ROUTES_KEY = makeStateKey<PageFullUrls[]>('dynamicRoutes');
export const TOKEN_KEY = makeStateKey<string>('login');
